import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogActions, Button, Box, TextField } from "@mui/material";
import { LocalizationProvider, MobileDateTimePicker, DateTimeField } from '@mui/x-date-pickers';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from 'dayjs/plugin/timezone';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(dayjs.tz.guess());

const EditEndDateDialog = ({ open, onClose, row, onSave }) => {
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    // Set the initial end date when the row prop changes
    if (row && row.datetime_end) {
      const localDate = dayjs.utc(row.datetime_end).local();
      setEndDate(localDate);
    }
  }, [row]);

  const handleSave = () => {
    if (endDate) {
      onSave(row.id, endDate.utc().format("YYYY-MM-DD HH:mm:ss"));
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimeField
              value={endDate}
              onChange={(newDate) => setEndDate(newDate)}
              format="YYYY/MM/DD HH:mm"
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    style: {
                      padding: "4px",
                      fontSize: "14px",
                    },
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={!endDate}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditEndDateDialog;
